import React from "react";
import ReportDataTable from "./ReportDataTable";

const columns = [
  { label: "S/N", key: "serial", render: (row) => row.serial },
  { label: "Order Date", key: "date", render: (row) => String(row.date || "--------").slice(0, 10) },
  { label: "Order Id", key: "order_id", render: (row) => row.o_id || row.order_id || row.id || "--------" },
  { label: "Taxable Amount(Rs.)", key: "amount", render: (row) => Number(row.amount || 0).toFixed(2) },
  { label: "CGST(Rs.)", key: "cgst", render: (row) => Number(row.cgst || 0).toFixed(2) },
  { label: "SGST(Rs.)", key: "sgst", render: (row) => Number(row.sgst || 0).toFixed(2) },
  { label: "Grand Total(Rs.)", key: "grand_total", render: (row) => Number(row.grand_total || 0).toFixed(2) },
];

const GstReport = ({ rows = [], loading }) => (
  <ReportDataTable
    columns={columns}
    rows={rows.map((row, index) => ({ ...row, serial: index + 1 }))}
    loading={loading}
    emptyMessage="No GST report data found."
  />
);

export default GstReport;
